(function(angular) {
    angular.module('bizPartEngage').controller('modules.forums', forumsController);
    angular.module('bizPartEngage').controller('modules.forum', forumController);
    angular.module('bizPartEngage').controller('modules.forum.thread', forumThreadController);

    forumsController.$inject = ["$rootScope", "modules.forum.service", "$state"];
    forumController.$inject = ["$rootScope", "modules.forum.service", "$stateParams", "$state"];
    forumThreadController.$inject = ["$rootScope", "modules.forum.service", "$stateParams", "$mdDialog", "$translate", "bizUser", "bizCore"];

    function forumsController($rootScope, forumService, $state) {
        var vm = this;
        vm.Forums = [];

        vm.GetForums = GetForums;
        vm.GoToForum = GoToForum;

        function GetForums() {
            forumService.GetForums().then(GetForumsSuccess);

            function GetForumsSuccess(response) {
                vm.Forums = response.data;
            }
        }

        function GoToForum(forum) {
            $state.go("base.modules.forum", {id: forum.Id});
        }

        function Init() {
            vm.GetForums();
        }

        this.$onInit = Init;
    }

    function forumController($rootScope, forumService, $stateParams, $state) {
        var vm = this;
        vm.ForumId = ~~$stateParams.id;
        vm.Forum = {
            Threads: []
        };

        vm.GetForum = GetForum;
        vm.GoToThread = GoToThread;

        function GetForum() {
            forumService.GetForum(vm.ForumId).then(GetForumSuccess);

            function GetForumSuccess(response) {
                vm.Forum = response.data;
            }
        }

        function GoToThread(thread) {
            $state.go("base.modules.forumthread", {id: thread.Id});
        }

        function Init() {
            if(vm.ForumId > 0) {
                vm.GetForum();
            }
        }

        this.$onInit = Init;
    }

    function forumThreadController($rootScope, forumService, $stateParams, $mdDialog, $translate, bizUserProvider, bizCoreProvider) {
        var vm = this;
        vm.ThreadId = ~~$stateParams.id;
        vm.Thread = {};
        vm.Post = {
            ForumThreadId: vm.ThreadId,
            UserId: bizUserProvider.getLoggedInUser().Id,
            Text: ""
        };

        vm.GetThread = GetThread;
        vm.SubmitPost = SubmitPost;
        vm.EditPost = EditPost;
        vm.DeletePost = DeletePost;
        vm.ThreadRead = ThreadRead;

        function GetThread() {
            if(vm.ThreadId > 0) {
                forumService.GetThread(vm.ThreadId).then(GetThreadSuccess);
            }

            function GetThreadSuccess(response) {
                vm.Thread = response.data;
            }
        }

        function SubmitPost(post) {
            forumService.SubmitPost(post).then(SubmitPostSuccess);

            function SubmitPostSuccess(response) {
                //Vi sätter tråden till läst när man postar i den. 
                vm.ThreadRead();
                if(response.data.Success == true && ~~post.Id <= 0) {
                    vm.Thread.ThreadEntrys.push(response.data.ExtraInfo);

                    vm.Post = {
                        ForumThreadId: vm.ThreadId,
                        UserId: $rootScope.LoggedInUser.Id,
                        Text: ""
                    };
                }
                else if(~~post.Id > 0) {
                    post.IsEditing = false;
                    console.log('Saved post successfully!');
                }
                else {
                    console.error(response.data.Message);
                }
            }
        }

        function EditPost(post) {
            post.IsEditing = true;
        }

        function DeletePost(post) {
            $translate('FORUM.ASKDELETEPOST').then(function (translation) {
                $mdDialog.show({
                    templateUrl: bizCoreProvider.getView('base.dialog', 'FrontEnd/Views/Dialogs/dialog-primary.html'),
                    controller: deletePostController,
                    controllerAs: "vm",
                    locals: {
                        Text: translation
                    },
                    bindToController: true
                }).then(function (response) {
                    if(response) {
                        forumService.DeletePost(post.Id).then(DeletePostSuccess);
                    }
                });
            });

            function DeletePostSuccess(response) {
                if(response.data.Success) {
                    vm.Thread.ThreadEntrys.splice(vm.Thread.ThreadEntrys.indexOf(post), 1);
                }
            }
        }

        deletePostController.$inject = ["$mdDialog"];

        function deletePostController($mdDialog) {
            var vm = this;

            vm.Close = Close;
            vm.Ok = Ok;

            function Close() {
                $mdDialog.cancel();
            }

            function Ok() {
                $mdDialog.hide(true);
            }
        }

        function ThreadRead() {
            if (~~bizUserProvider.getLoggedInUser().Id > 0 && ~~vm.ThreadId > 0) {
                forumService.ThreadRead(vm.ThreadId);
            }
        }

        function Init() {
            vm.GetThread();
            vm.ThreadRead();
        }

        this.$onInit = Init;
    }
})(window.angular);
